





















import {
  ProjectListType,
} from "@/data/models/ProjectOverview";
import { COLOR_PROJECT_TYPE_ARCHIVED, COLOR_PROJECT_TYPE_DELETED, COLOR_PROJECT_TYPE_FINISHED, COLOR_PROJECT_TYPE_RUNNING } from "@/utils/colors";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ProjectListTypeDisplayComponent extends Vue {
  @Prop() projectListType!: ProjectListType;
  @Prop({ default: false }) showText!: boolean;
  @Prop({ default: false }) addMarginRight!: boolean;

  get projectListTypeColor() {
    switch (this.projectListType) {
      case ProjectListType.RUNNING_PROJECTS:
        return COLOR_PROJECT_TYPE_RUNNING;
      case ProjectListType.FINISHED_PROJECTS:
        return COLOR_PROJECT_TYPE_FINISHED;
      case ProjectListType.ARCHIVED_PROJECTS:
        return COLOR_PROJECT_TYPE_ARCHIVED;
      case ProjectListType.DELETED_PROJECTS:
        return COLOR_PROJECT_TYPE_DELETED;

      default:
        return "";
    }
  }

  get projectListTypeBorder() {
    switch (this.projectListType) {
      case ProjectListType.ARCHIVED_PROJECTS:
        return "1px solid black";

      default:
        return "";
    }
  }

  get projectListTypeText() {
    switch (this.projectListType) {
      case ProjectListType.RUNNING_PROJECTS:
        return this.$t("projectList.types.running").toString();
      case ProjectListType.FINISHED_PROJECTS:
        return this.$t("projectList.types.finished").toString();
      case ProjectListType.ARCHIVED_PROJECTS:
        return this.$t("projectList.types.archived").toString();
      case ProjectListType.DELETED_PROJECTS:
        return this.$t("projectList.types.deleted").toString();

      default:
        return "";
    }
  }
}
